import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../base/button';
import FormikFieldWrapper from '../base/forms/formikFieldWrapper';
import FormikSelect from '../base/forms/formikSelect';
import { StyledFormikField, StyledFormikTextArea } from '../base/forms/input';
import { Column, Columns } from '../base/grid';

interface Props {
	values: any;
	setFieldTouched: any;
	setFieldValue: any;
	isSubmitting: boolean;
	errors: any;
	touched: any;
}

const CustomerOpinionsFormFields: FC<Props> = ({ values, setFieldTouched, setFieldValue, isSubmitting }) => {
	const { t } = useTranslation(['generalForm', 'forms']);

	const selectOptions = [
		{ value: '0', label: t('forms:messageTypeOptions.option1') },
		{ value: '1', label: t('forms:messageTypeOptions.option2') },
		{ value: '2', label: t('forms:messageTypeOptions.option3') },
	];

	return (
		<div>
			<Columns>
				<Column desktopSmall={1 / 2}>
					<FormikFieldWrapper name="email" languageComponent="generalForm" label={t('email')} smallLabel>
						<StyledFormikField type="text" id="email" name="email" placeholder={t('email')} />
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 2}>
					<FormikFieldWrapper
						name="messageType"
						languageComponent="generalForm"
						label={`${t('forms:messageType')}*`}
						smallLabel>
						<FormikSelect
							id="messageType"
							name="messageType"
							value={values.messageType}
							options={selectOptions}
							placeholder={t('choose')}
							onBlur={setFieldTouched}
							onChange={setFieldValue}
						/>
					</FormikFieldWrapper>
				</Column>
			</Columns>

			<Columns>
				<Column>
					<FormikFieldWrapper
						name="comments"
						label={`${t('forms:comments')}*`}
						smallLabel
						languageComponent="generalForm">
						<StyledFormikTextArea
							type="text"
							component="textarea"
							id="comments"
							name="comments"
							padding="1rem"
							placeholder={t('forms:comments')}
						/>
					</FormikFieldWrapper>
				</Column>
			</Columns>

			<Columns>
				<Column>
					<Button wide primary type="submit" isLoading={isSubmitting}>
						{t('submit')}
					</Button>
				</Column>
			</Columns>
		</div>
	);
};

export default CustomerOpinionsFormFields;
